module.exports = __webpack_public_path__ + "img/opfer_tatort_px.77f12d27.png";